import { inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor } from '@angular/common/http';
import { finalize } from 'rxjs/operators';

import { LoadingService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class LoadingInterceptor implements HttpInterceptor {
  private readonly loadingService = inject(LoadingService);

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const requestId = this.loadingService.startLoading();
    return next.handle(request).pipe(finalize(() => this.loadingService.stopLoading(requestId)));
  }
}
